<template>
	<div class="register">
		<div class="top">
			<img class="logo" src="../../static/img/logo.png" />
			<h5 class="top_tit"><span>|</span> 会员管理系统</h5>
			<router-link class="qiye"  to="/register">
				企业入会
			</router-link>
			<router-link class="geren"  to="/register1">
				个人入会
			</router-link>
			<router-link class="back"  to="/login">
				返回登录
			</router-link>
		</div>
		<div class="con">
			<el-form :model="ruleForm" :rules="rules" ref="ruleForm"  class="demo-ruleForm ">
			    <h3 class="title"><span></span><strong>加入会员-个人入会</strong></h3>	
			    <div class="middle">
			    	<div class="iptbox">
			    		<span>注册邮箱</span>
			    		<el-form-item style="width: 300px;height: 40px;float: right;margin-bottom: 0;"
						    prop="email"
						    :rules="[
						      { required: true, message: '请输入邮箱地址', trigger: 'blur' },
						      { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
						    ]"
						>						
						    <el-input class="email" v-model="ruleForm.email" placeholder="请输入有效的电子邮箱" clearable></el-input>
						</el-form-item>
			    	</div>
				    <!--用户名-->
				    <div class="iptbox">
				    	<span>用户名</span>	
				    	<el-form-item style="width: 300px;height: 40px;float: right;margin-bottom: 0;"  prop="account">	    	
					      	<el-input class="user" type="text" v-model="ruleForm.account" auto-complete="off" placeholder="请输入用户名或昵称（登陆使用）" clearable></el-input>
					    </el-form-item>
				    </div>
				    
				    <!--密码-->
				    <div class="iptbox">
				    	<span>密码</span>
				    	<el-form-item style="width: 300px;height: 40px;float: right;margin-bottom: 0;" prop="pass">
						    <el-input  class="password" type="password" v-model="ruleForm.pass" autocomplete="off" placeholder="最少6位数字+字母密码(区分大小写)" show-password></el-input>
						</el-form-item>
				    </div>
				   
				   <div class="iptbox">
				   		<span>确认密码</span>
				   		<el-form-item  prop="checkPass" style="width: 300px;height: 40px;float: right;margin-bottom: 0;">
						    <el-input  class="sure_password" type="password" v-model="ruleForm.checkPass" autocomplete="off" placeholder="重复输入密码，保持一致" show-password></el-input>
						</el-form-item>
				   </div>
					
				    
				    <!--验证码-->
				    <div class="drag" ref="dragDiv">
				        <div class="drag_bg"></div>
				        <div class="drag_text">{{confirmWords}}</div>
				        <div ref="moveDiv" @mousedown="mousedownFn($event)" :class="{'handler_ok_bg':confirmSuccess}" class="handler handler_bg" style="position: absolute;top: 0px;left: 0px;"></div>
				   </div>
				       			    
				    <!--提交-->	
				    <el-form-item style="width: 160px;display: block;margin: 0 auto;">
				      	<el-button class="btn" type="primary" style="width:100%;" @click.native.prevent="onSubmit">立即注册</el-button>
				    </el-form-item>
			    </div>
			    <div class="see">
				    <input type="radio" v-model="checked" class="radio" value="1" />阅读并同意
				    <router-link  target="_blank" class="pro" to="/registerRule">《中国质量协会章程》</router-link><router-link  target="_blank" class="pro" to="/convention">《中国质量协会会员企业质量诚信自律公约》</router-link>以及<router-link  target="_blank" class="pro" to="/agreement">《用户协议》</router-link>				    	
				</div>
			</el-form>
		</div>
		<div class="shade" v-if='show'>
			<div class="tc">
				<p>提示</p>
				<span>注册成功！</span>
				<br>
				<router-link to='login'>返回登录页面</router-link>
			</div>
		</div>
		<bottom></bottom>
	</div>
</template>

<script>
	import Qs from 'qs'
	import bottom from './Bottom'
  	export default {
  		components: {
			bottom
		},
	    data() {
	      	var validatePass = (rule, value, callback) => {
		        if (value === '') {
		          callback(new Error('请输入密码'));
		        } else {
		          if (this.ruleForm.checkPass !== '') {
		            this.$refs.ruleForm.validateField('checkPass');
		          }
		          callback();
		        }
	      	};
		    var validatePass2 = (rule, value, callback) => {
		        if (value === '') {
		          callback(new Error('请再次输入密码'));
		        } else if (value !== this.ruleForm.pass) {
		          callback(new Error('两次输入密码不一致!'));
		        } else {
		          callback();
		        }
		    };
		    return {
		    	beginClientX:0,           /*距离屏幕左端距离*/
		        mouseMoveStata:false,     /*触发拖动状态  判断*/
		        maxwidth:'',               /*拖动最大宽度，依据滑块宽度算出来的*/
		        confirmWords:'拖动滑块验证',   /*滑块文字*/
		        confirmSuccess:false,          /*验证成功判断*/
		    	checked:'',
		    	show:false,
		        ruleForm: {
		        	account: '',
			        pass: '',
			        checkPass: '',
			        email:''
		        },
		        rules: {
		        	account: [
			            { required: true, message: '请输入账号', trigger: 'blur' },
			        ],
			        pass: [
			            { validator: validatePass, trigger: 'blur' },
			            { pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,}$/, message: '最少6位数字+字母密码' }
       				],
        			
			        checkPass: [
			            { validator: validatePass2, trigger: 'blur' }
			        ]
		    	}
		    };
	    },
		created() {
	  	},
	  	mounted() {
		    this.maxwidth = this.$refs.dragDiv.clientWidth - this.$refs.moveDiv.clientWidth;
	        document.getElementsByTagName('html')[0].addEventListener('mousemove',this.mouseMoveFn);
	        document.getElementsByTagName('html')[0].addEventListener('mouseup',this.moseUpFn)
		},
	    methods: {
	    	 mousedownFn:function (e) {
                if(!this.confirmSuccess){
                    e.preventDefault && e.preventDefault();   //阻止文字选中等 浏览器默认事件
                    this.mouseMoveStata = true;
                    this.beginClientX = e.clientX;
                }
            },        //mousedoen 事件
            successFunction(){
                this.confirmSuccess = true
                this.confirmWords = '验证通过';
                if(window.addEventListener){
                    document.getElementsByTagName('html')[0].removeEventListener('mousemove',this.mouseMoveFn);
                    document.getElementsByTagName('html')[0].removeEventListener('mouseup',this.moseUpFn);
                }else {
                    document.getElementsByTagName('html')[0].removeEventListener('mouseup',()=>{});
                }
                document.getElementsByClassName('drag_text')[0].style.color = '#fff'
                document.getElementsByClassName('handler')[0].style.left = this.maxwidth + 'px';
                document.getElementsByClassName('drag_bg')[0].style.width = this.maxwidth + 'px';
            },                //验证成功函数
            mouseMoveFn(e){
                if(this.mouseMoveStata){
                    let width = e.clientX - this.beginClientX;
                    if(width>0 && width<=this.maxwidth){
                        document.getElementsByClassName('handler')[0].style.left = width + 'px';
                        document.getElementsByClassName('drag_bg')[0].style.width = width + 'px';
                    }else if(width>this.maxwidth){
                        this.successFunction();
                    }
                }
            },                   //mousemove事件
            moseUpFn(e){
                this.mouseMoveStata = false;
                var width = e.clientX - this.beginClientX;
                if(width<this.maxwidth){
                    document.getElementsByClassName('handler')[0].style.left = 0 + 'px';
                    document.getElementsByClassName('drag_bg')[0].style.width = 0 + 'px';
                }
            },                   
		    onSubmit(ev) {
		        this.$refs.ruleForm.validate((valid) => {
		        	if (valid) {
			            if(!this.confirmSuccess){
	        				this.$toast('请通过验证');
	        				return false;
		        		}
			            if(this.checked==''){
	        				this.$toast('请选择同意 《入会章程》及《用户协议》');
	        				return false;
		        		}
						let data ={
							'email': this.ruleForm.email,
							'username':this.ruleForm.account,
							'password':this.ruleForm.pass,
							'repassword':this.ruleForm.checkPass,
							'type':3
						};
						this.$axios({
							method: 'post',
						    url: 'user/reg',
						    data: Qs.stringify(data)
						}).then(response => {	
			            	if(response.data.state==1){
			            		this.show = true;
//			            		this.$toast('注册成功，3秒后返回登录页');
//			            		var _this=this;
//			            		setTimeout(function(){
//			            			_this.$router.push('/login');
//			            		},3000);			            				            		
			            	}else{
			            		this.$toast(response.data.msg);
			            	}
				    	});
			        }		        	
		       });	
		    },
	    }
	}

</script>
<style scoped >
.register {
	width: 100%;
	height: auto;
	background: #fff;
	font-family: PingFangSC-Medium;
	font-size: 20px;
}

.top {
	height: 80px;
	position: relative;
}

.logo {
	width: 211px;
	height: 43px;
	position: absolute;
	top: 16px;
	left: 254px;
}

.top_tit {
	position: absolute;
	top: 26px;
	left: 480px;
	height: 28px;
	font-weight: bold;
	color: rgba(0, 94, 179, 1);
	line-height: 28px;
}

.top_tit span {
	height: 17px;
	color: #E8E8E8;
}
.qiye{
	position: absolute;
	top: 30px;
	right: 445px;
	font-size: 14px;
	font-weight: bold;
	line-height: 20px;
}
.back,.geren{
	position: absolute;
	top: 30px;
	right: 249px;
	font-size: 14px;
	font-weight: bold;
	color: rgba(128, 128, 128, 1);
	line-height: 20px;
}
.geren{
	color: #FF9600;
	right: 345px;
}

.con {
	border-top: 1px solid rgba(0, 0, 0, 0);
	box-sizing: border-box;
	width: 100%;
	height: 600px;
	background: rgba(246, 248, 249, 1);
}

.demo-ruleForm {
	width: 800px;
	height: 518px;
	background: #fff;
	margin: 39px auto 0;
}

.title {
	text-align: left;
	height: 54px;
	vertical-align: middle;
	line-height: 54px;
	text-indent: 15px;
	background: #0076FF;
	/*border-bottom: 2px solid #EEEEEE;*/
}

/*.title span {
	display: inline-block;
	width: 8px;
	height: 20px;
	background: rgba(0, 94, 178, 1);
	margin: 0 11px 0 13px;
	vertical-align: middle;
}*/

.title strong {
	display: inline-block;
	font-size: 20px;
	line-height: 28px;
	font-family: PingFangSC-Medium;
	font-weight: bold;
	color: #fff;
	/*color: rgba(0, 94, 178, 1);*/
	vertical-align: middle;
}

.middle {
	width: 370px;
	height: auto;
	margin: 20px auto 0;
}

.iptbox {
	width: 100%;
	height: 40px;
	position: relative;
	margin-bottom: 20px;
}

.iptbox span {
	position: absolute;
	left: 0;
	line-height: 40px;
	width: 56px;
	height: 40px;
	font-size: 14px;
	font-family: PingFangSC-Regular;
	font-weight: 400;
	color: rgba(100, 100, 100, 1);
}

.drag{
    position: relative;
    background-color: #e8e8e8;
    width: 100%;
    height: 40px;
    line-height: 40px;
    text-align: center;
    margin-bottom: 25px;
}
.handler{
    width: 40px;
    height: 38px;
    border: 1px solid #ccc;
    cursor: move;
}
.handler_bg{
    background: #fff url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA3hpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDIxIDc5LjE1NTc3MiwgMjAxNC8wMS8xMy0xOTo0NDowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDo0ZDhlNWY5My05NmI0LTRlNWQtOGFjYi03ZTY4OGYyMTU2ZTYiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NTEyNTVEMURGMkVFMTFFNEI5NDBCMjQ2M0ExMDQ1OUYiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NTEyNTVEMUNGMkVFMTFFNEI5NDBCMjQ2M0ExMDQ1OUYiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTQgKE1hY2ludG9zaCkiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo2MTc5NzNmZS02OTQxLTQyOTYtYTIwNi02NDI2YTNkOWU5YmUiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6NGQ4ZTVmOTMtOTZiNC00ZTVkLThhY2ItN2U2ODhmMjE1NmU2Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+YiRG4AAAALFJREFUeNpi/P//PwMlgImBQkA9A+bOnfsIiBOxKcInh+yCaCDuByoswaIOpxwjciACFegBqZ1AvBSIS5OTk/8TkmNEjwWgQiUgtQuIjwAxUF3yX3xyGIEIFLwHpKyAWB+I1xGSwxULIGf9A7mQkBwTlhBXAFLHgPgqEAcTkmNCU6AL9d8WII4HOvk3ITkWJAXWUMlOoGQHmsE45ViQ2KuBuASoYC4Wf+OUYxz6mQkgwAAN9mIrUReCXgAAAABJRU5ErkJggg==") no-repeat center;
}
.handler_ok_bg{
        background: #fff url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA3hpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDIxIDc5LjE1NTc3MiwgMjAxNC8wMS8xMy0xOTo0NDowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDo0ZDhlNWY5My05NmI0LTRlNWQtOGFjYi03ZTY4OGYyMTU2ZTYiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NDlBRDI3NjVGMkQ2MTFFNEI5NDBCMjQ2M0ExMDQ1OUYiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NDlBRDI3NjRGMkQ2MTFFNEI5NDBCMjQ2M0ExMDQ1OUYiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTQgKE1hY2ludG9zaCkiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDphNWEzMWNhMC1hYmViLTQxNWEtYTEwZS04Y2U5NzRlN2Q4YTEiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6NGQ4ZTVmOTMtOTZiNC00ZTVkLThhY2ItN2U2ODhmMjE1NmU2Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+k+sHwwAAASZJREFUeNpi/P//PwMyKD8uZw+kUoDYEYgloMIvgHg/EM/ptHx0EFk9I8wAoEZ+IDUPiIMY8IN1QJwENOgj3ACo5gNAbMBAHLgAxA4gQ5igAnNJ0MwAVTsX7IKyY7L2UNuJAf+AmAmJ78AEDTBiwGYg5gbifCSxFCZoaBMCy4A4GOjnH0D6DpK4IxNSVIHAfSDOAeLraJrjgJp/AwPbHMhejiQnwYRmUzNQ4VQgDQqXK0ia/0I17wJiPmQNTNBEAgMlQIWiQA2vgWw7QppBekGxsAjIiEUSBNnsBDWEAY9mEFgMMgBk00E0iZtA7AHEctDQ58MRuA6wlLgGFMoMpIG1QFeGwAIxGZo8GUhIysmwQGSAZgwHaEZhICIzOaBkJkqyM0CAAQDGx279Jf50AAAAAABJRU5ErkJggg==") no-repeat center;
}
.drag_bg{
    background-color: #7ac23c;
    height:40px;
    width: 0px;
}
.drag_text{
    position: absolute;
    top: 0px;
    width: 100%;text-align: center;
    -moz-user-select: none;
    -webkit-user-select: none;
    user-select: none;
    -o-user-select:none;
    -ms-user-select:none;
}

.btn {
	display: block;
	margin: 0 auto 23px;
	width: 160px;
	height: 48px;
	background: rgba(255, 150, 0, 1);
	border-radius: 4px;
	border: none;
}

.see {
	font-size: 14px;
	font-weight: 400;
	color: rgba(79, 79, 79, 1);
	line-height: 15px;
	vertical-align: middle;
}
.see a{
	display: inline-block;
}
.radio {
	vertical-align: top;
}

.pro {
	color: #3498DB;
}
.shade{
	position: fixed;
	left: 0;
	top: 0;
	width: 100%;
	height: 100%;
	background:rgba(0,0,0,.7) ;
}
.tc{
	font-size: 18px;
	width: 380px;
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%,-50%);
	background: #fff;
	padding-bottom: 15px;
}
.tc p{
	text-indent: 12px;
	text-align: left;
	height: 45px;
	line-height: 45px;
	background: #2169d3;
	color: #fff;
	margin-bottom: 30px;
}
.tc span{
	display: inline-block;
	height: 50.5px;
	line-height: 50.5px;
	padding-left: 70px;
	background: url(../../static/img/icon28.png) no-repeat left center;
	background-size:53.3px 50.5px ;
	font-size: 20px;
	color: #000;
	margin-bottom: 35px;
}
.tc a{
	font-size: 18px;
	cursor: pointer;
	border-radius: 5px;
	background:rgba(0,95,179,1);
	display: inline-block;
	border: 2px solid #6486b7;
	padding: 1px 8px;
	color: #fff;
}
.tc a:hover{
	background:rgba(0,95,179,.6);
}
</style>



// WEBPACK FOOTER //
// src/components/Register1.vue